import customAxios from "middleware/customAxios";

/**
 * Fetch CRM "customers" from CRM devices via backend proxy (API key stays on server).
 * When code is provided, backend returns only devices matching that 6‑digit code.
 * Returns array of { id, name, accountNumber, source } where accountNumber = code.
 */
export async function getCrmContacts(code = "") {
  const params = code ? { code } : {};
  const query = new URLSearchParams(params).toString();
  const url = query ? `/admin/crm/devices?${query}` : "/admin/crm/devices";

  try {
    const data = await customAxios.get(url);
    const list = Array.isArray(data) ? data : [];
    return list;
  } catch (err) {
    return [];
  }
}
